import { render, staticRenderFns } from "./wageSearch.vue?vue&type=template&id=ecfb1a00&scoped=true&"
import script from "./wageSearch.vue?vue&type=script&lang=js&"
export * from "./wageSearch.vue?vue&type=script&lang=js&"
import style0 from "./wageSearch.vue?vue&type=style&index=0&id=ecfb1a00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfb1a00",
  null
  
)

export default component.exports